var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"we-panel-item",style:(_vm.getStyle)},[_vm._t("default",null,{"width":_vm.currentWidth})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }